import {api} from './api';

export const planTagsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planTagsCreate: builder.mutation({
			query: ({planId, name}) => ({
				url: 'planTags',
				method: 'POST',
				body: {planId, name},
			}),
			invalidatesTags: ['PlanInfo', 'GlobalTags'],
		}),
		planTagsDelete: builder.mutation({
			query: ({id}) => ({
				url: `planTags/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PlanInfo', 'GlobalTags'],
		}),
	}),
});

export const { usePlanTagsCreateMutation, usePlanTagsDeleteMutation } = planTagsApi;
